<template>
	<div class="allbg">
		<!-- 头 -->
		<tyheader pageind="3"/>
		<section class="n_container">
			<div class="w1400">
				<div class="main-container">
					<div class="edit-container">
						<div class="clearfix" style="margin-top:40px;padding-bottom: 40px;border-bottom: 1px solid #ddd;margin-bottom: 40px;display: flex;justify-content: space-between;">
				
							<div class="wid100" style="width: 35%;border: 1px solid #ddd;margin-right: 5%">
								<swiper class="bannerind" :options="swiperOption" ref="mySwiper">
								  <swiper-slide v-for="(item, index) in proinfo.banner" :key="index">
											<img :src="item" ></img>
									</swiper-slide>
								</swiper>
								<!-- <img :src="proinfo.showImg"> -->
							</div>
				
							<div class="wid100" style="width: 30%;margin-right: 5%">
								<div class="about-title">
									<p class="h2"><span style="font-size: 36px;">{{proinfo.name}}<i></i></span></p>
								</div>
								<div v-html="proinfo.synopsis"></div>
							</div>
				
							<div class="wid100" style="width: 25%;">
								<a class="goumai" href="https://shuanggou.tmall.com/view_shop.htm?spm=a1z10.1-b-s.w5001-22979499583.10.37112dedNglyIi&shop_id=376495687&rn=1de257b182c5d2f11a970a4d9c07f642&scene=taobao_shop" target="_blank"><img src="../assets/images/tianmao.png"></a>
								<a class="goumai" href="https://mall.jd.com/index-700599.html" target="_blank"><img src="../assets/images/jingdong.png"></a>
								<a class="goumai" href="https://shuanggou.suning.com/" target="_blank"><img src="../assets/images/suning.png"></a>
				
								<p style="font-size: 20px;line-height: 1.5;margin-bottom: 10px;color: #333;margin-top: 44px;">规格参数</p>
								<h6>酒精度：{{proinfo.Vol}}</h6>
								<h6>原料：{{proinfo.rawmaterial}}</h6>
								<h6>香型：{{proinfo.scent}}</h6>
								<!-- <h6>产地：江苏 宿迁</h6> -->
								<h6>等级：{{proinfo.levels}}</h6>
								<h6>净含量：{{proinfo.specification}}</h6>
								<h6>储存方法：{{proinfo.store}}</h6>
							</div>
						</div>
					 
					 <div v-html="proinfo.details"></div>
						<div class="backpage" @click="backpage()">返回</div>
					</div>
				</div>
			</div>
		</section>
		
		
		<tyfooter></tyfooter>
	</div>
</template>

<script>
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	export default {
	  name: 'product',
		components: {
			swiper,
			swiperSlide,
			tyheader,
			tyfooter
		},
		metaInfo () {
			return {
				title: this.seot,
				meta: [   // set meta
					{                
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data(){
			return{
				seot:this.COMMON.seotit,
				seod:this.COMMON.seodec,
				seok:this.COMMON.seokey,
				isshow:this.COMMON.isshow(),
				procode:'',
				proinfo:'',
				imgurl:this.COMMON.imgurl,
				swiperOption: {
				  loop: true,
				},
			}
		},
		computed:{
			swiper() {
			  return this.$refs.mySwiper.swiper;
			},
		},
		mounted() {
			this.procode = this.$route.query.type
			this.getprodetail()
			that.$axios.post('/w/pageseo?address='+'/prodetail').then(function (response) {
				if(JSON.stringify(response.data) != "{}"){
					// that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function (error) {
					console.log(error);
			});
		},
		methods:{
			backpage(){
				this.$router.go(-1)
			},
			getprodetail(){
				let that = this
				this.$axios.post('/w/p?categoryCode=&&code='+that.procode).then(function (response) {
					response.data[0].banner = response.data[0].banner.split(',')
					let newarry = []
					response.data[0].banner.forEach((val,ind) => {
						val = that.imgurl + val
						newarry.push(val)
					})
					response.data[0].banner = newarry
					response.data[0].showImg = that.imgurl + response.data[0].showImg
					that.proinfo = response.data[0]
					that.seot = response.data[0].name + ' - 江苏双沟酒业股份有限公司'
				})
				.catch(function (error) {
					console.log(error);
				});
			},
		},
		watch:{
			
		}
	}
</script>

<style scoped="scoped">
	body{background-color: #ffffff !important;}
	.n_container {
	    background: url(../assets/images/n_container_bg.jpg) center bottom no-repeat #ffffff;
	    background-size: 100% auto;
	    width: 100%;
	}
	article, aside, footer, header, nav, section {
	    display: block;
	}
	.main-container {
	    position: relative;
	    padding-bottom: 50px;
	}
	.edit-container {
    font-size: 16px;
    color: #576066;
    line-height: 2em;
    min-height: 1em;
    text-align: justify;
    padding-top: 20px;
}
.clearfix {
    zoom: 1;
}
.clearfix:before, .clearfix:after {
    content: "";
    display: table;
}
img {
    border-style: none;
    max-width: 100%;
    vertical-align: top;
    width: auto!important;
    height: auto!important;
}
.about-title {
    color: #3d3d3d;
}
.about-title .h2, .about-title .h3 {
    font-size: 22px;
    line-height: 1em;
    padding-bottom: 8px;
    font-weight: normal;
}
.about-title .h2 span {
    font-weight: bold;
    font-family: 'syst';
}
.about-title .h2 span i {
    display: inline-block;
    width: 10px;
    height: 10px;
    border: 1px solid #119e7f;
    vertical-align: text-top;
    border-radius: 100%;
    margin-left: 2px;
}
.goumai {
    color: #333;
    display: inline-block;
    text-align: center;
    margin-top: 20px;
    font-size: 16px;
    margin-right: 10px;
}
	@media screen and (max-width: 767px) {
		.n_title{height: 50px;}
		.n_nav a{height: 50px;line-height: 50px;}
		.position{line-height: 50px;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAuElEQVQokZXRoU4DQRQF0LOT0RtCkKTB9Qdo+QY0hg+ApAKaFQj6G8XVUlldW40kCMjK6josEMxsMkyWQK95L3PnJJNM1TSNnsxwh0XafyT2gDlu036PI1znF0IBVhnocoV1H6rxhIu+t+I89YcdOsMLxr+ALmM8YxSwxOAP0OUYjwGX+PgngknAK772QG3EAaqieECLIW6Kro4JlGia7SWqQgLlJ58UM0+M2GGD06z4zOZ7dv6G7TfQZhwU9L0NbQAAAABJRU5ErkJggg==) left 19px no-repeat;}
	  .left{width: 7rem;
	  height: 50px;
	  overflow: hidden;}
		.left{background: url(../assets/images/downarr.png) right 15px no-repeat ;background-size: 20px;}
		.left:hover{height:auto;background: url(../assets/images/downarr.png) right 15px no-repeat #ffffff;background-size: 20px;box-shadow: 0px 0px 10px rgb(0,0,0,0.5);}
		.clearfix{
			display: block !important;
		}
		.wid100{width: 100% !important;}
		.wid100 p,.wid100 p span{font-size: 28px !important;}
		.n_nav a{margin-right: 0px;}
	}
	
</style>
